import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ShieldCheck, Sparkles } from 'lucide-react';
export function CTASection() {
  return <section id="cta-section" className="py-32 bg-[#050b14] relative overflow-hidden" data-id="element-1">
      {/* Golden glow effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#d4af37]/5 rounded-full blur-[100px]" data-id="element-2" />

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10" data-id="element-3">
        <FadeIn data-id="element-4">
          <h2 className="text-4xl md:text-6xl text-white mb-8 leading-tight" data-id="element-5">
            Si estás listo para dejar de ser <br data-id="element-6" />
            <span className="text-[#d4af37] italic" data-id="element-7">
              el que siempre empieza…
            </span>
          </h2>

          <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-2xl mx-auto" data-id="element-8">
            Y convertir tu fe en estructura diaria.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-9">
          <div className="flex flex-col items-center gap-8" data-id="element-10">
            {/* Price Box */}
            <div className="bg-gradient-to-br from-[#1e3a5f]/40 to-[#0a1628]/40 border-2 border-[#d4af37] rounded-2xl p-8 md:p-12 shadow-[0_0_60px_rgba(212,175,55,0.15)] max-w-md w-full cursor-pointer transition-all duration-300 hover:shadow-[0_0_80px_rgba(212,175,55,0.25)] hover:border-[#d4af37]/80" onClick={() => window.open('https://pay.hotmart.com/S104255087F?checkoutMode=10&bid=1770183530018', '_blank')} data-id="element-11">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#d4af37]/10 border border-[#d4af37]/30 rounded-full mb-6" data-id="element-12">
                <Sparkles className="w-4 h-4 text-[#d4af37]" data-id="element-13" />
                <span className="text-[#d4af37] text-sm font-medium tracking-wide" data-id="element-14">
                  Precio Especial de Lanzamiento
                </span>
              </div>

              <div className="mb-6" data-id="element-15">
                <div className="text-6xl md:text-7xl font-bold text-[#d4af37] mb-2" data-id="element-16">
                  $6.39
                </div>
                <div className="text-gray-400 text-lg" data-id="element-17">
                  Acceso inmediato y completo
                </div>
              </div>
            </div>

            <Button className="w-full md:w-auto text-xl px-12 py-6 shadow-[0_0_40px_rgba(212,175,55,0.2)]" onClick={() => window.open('https://pay.hotmart.com/S104255087F?checkoutMode=10&bid=1770183530018', '_blank')} data-id="element-18">
              Consigue Hábitos Atómicos Espirituales
            </Button>

            <div className="flex items-center gap-2 text-gray-400 text-sm mt-2" data-id="element-19">
              <ShieldCheck className="w-4 h-4 text-[#d4af37]" data-id="element-20" />
              <span data-id="element-21">Pago único • Pago seguro</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}